<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Tenancies</div><h2>Owners</h2></div>
        </div>
        <div class="list-tabs" role="tablist" aria-label="Owners">
            <router-link role="tab" :aria-selected="String($route.path === '/buildium/rental-owners')" tag="button"
                         :class="{on: $route.path === '/buildium/rental-owners'}" to="/buildium/rental-owners">Rental owners</router-link>
            <router-link role="tab" :aria-selected="String($route.path === '/buildium/association-owners')" tag="button"
                         :class="{on: $route.path === '/buildium/association-owners'}" to="/buildium/association-owners">Association owners</router-link>
        </div>
        <div class="list-filters">
            <el-input v-model="params.q" class="list-search" clearable prefix-icon="el-icon-search"
                      placeholder="Name, company or email" aria-label="Search owners"/>
        </div>
        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="Id" label="ID" width="100"/>
                <el-table-column label="Name" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.FirstName }}</span>
                        <span>{{ scope.LastName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Email" label="Email"/>
                <el-table-column prop="AlternateEmail" label="Alternate Email"/>
                <el-table-column prop="CompanyName" label="Company"/>
                <el-table-column prop="Type" label="Type" width="100"/>
                <el-table-column prop="Status" label="Status" width="90">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsActive ? 'success' : 'danger'">
                            {{ scope.row.IsActive ? 'Active' : 'InActive' }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-button type="primary" size="small" @click="onBatchDelete">{{
                            $t('common.batch_delete')
                        }}
                    </el-button>
                </div>
                <div class="flex"></div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";

export default {
    name: "RentalOwners",
    mixins: [Pagination],
    data() {
        return {params: {q: ''}, autoSearch: true}
    },
    methods: {
        listApi() {
            return '/buildium/rentals/owners'
        },
        listParams() {
            return this.params;
        },
        onBatchDelete() {
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                let ids = this.selectionIds.map((d) => d.Id);
                this.loading = true;
                ApiService.delete('/buildium/rentals/owners/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
    },
    watch: {
        '$route.query.q'(value) {
            this.params.q = value || '';
        },
    },
    mounted() {
        if (this.$route.query.q) {
            this.params.q = this.$route.query.q;
        }
        this.fetchList();
    }
}
</script>

<style scoped>

</style>